import { search } from '../searchService';
import { post, put, del, getById } from '../apiService';
import type { Badge } from '../../types/content/badge';
import type { SearchParams } from '../../types/search';

export async function searchBadges(
  filter: object = {},
  params: SearchParams = {},
): Promise<Badge[]> {
  return search<Badge>('/badge/search', filter, params);
}

export async function getBadgeById(id: string): Promise<Badge> {
  return getById<Badge>('/badge', id);
}

export async function createBadge(data: Partial<Badge>): Promise<Badge> {
  return post<Badge>('/badge', data);
}

export async function updateBadge(id: string, data: Badge): Promise<Badge> {
  return put<Badge>(`/badge/${id}`, data);
}

export async function deleteBadge(id: string): Promise<void> {
  return del<void>(`/badge/${id}`);
}
